import $ from 'jquery'
import select2 from 'select2'
import 'select2/dist/css/select2.css'
import Modals from '../blocks/modals.js'

export default {
  init () {
    this.attachDeleteButtonClickHandler()
    this.openModal()
    this.submitButtonHandler('hs-submit-adherent', '', 'form-adherent')
    this.submitButtonHandler('hs-submit-enteprise', '', 'enteprise-form')
    select2($)
    $('.custom-select2').select2({
      placeholder: 'Choisir dans la liste'
    })
  },

  attachDeleteButtonClickHandler () {
    const deleteButtons = document.querySelectorAll('.list-adherent-item .btns a[id^="btn-delete-"]')
    deleteButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        const btnId = $(button).attr('data-url')
        console.log(btnId)
        console.log($('#confirm-btn a'))
        $('#confirm-btn a').attr('href', btnId)
        const modal = new Modals()
        modal.openModal('adherent-suppression-adherent')
      })
    })
  },

  openModal () {
    const modal = new Modals()
    let modalId = $('#modal-id').attr('data')
    let url = $('#modal-id').attr('url')

    if(url) {
      $('#return-user a').attr('href', url)
    }

    if(modalId) {
      modal.openModal(modalId)
    }
  },

  submitButtonHandler (buttonId, modalId, formId) {
    const submitButton = document.getElementById(buttonId)
    const form = document.getElementById(formId)
    if (submitButton) {
      submitButton.addEventListener('click', (event) => {
        event.preventDefault()
        const errorMessages = document.querySelectorAll('.hs-error-msgs label')
        errorMessages.forEach(errorMessage => {
          errorMessage.textContent = ''
        })
        const requiredFields = document.querySelectorAll('.hs-input[data-required="required"]')
        let hasError = false
        let firstEmptyField = null

        requiredFields.forEach(field => {
          if (field.tagName === 'SELECT' && field.multiple) {
            if (field.selectedOptions.length === 0) {
              const errorMessage = field.parentElement.querySelector('.hs-error-msgs label')
              errorMessage.textContent = 'Veuillez remplir ce champ'
              hasError = true
              if (!firstEmptyField) {
                firstEmptyField = field
              }
            }
          } else {
            if (!field.value.trim()) {
              const errorMessage = field.parentElement.querySelector('.hs-error-msgs label')
              errorMessage.textContent = 'Veuillez remplir ce champ'
              hasError = true
              if (!firstEmptyField) {
                firstEmptyField = field
              }
            }
          }
        })

        const emailFields = document.querySelectorAll('.hs-input[validate="email"]')

        emailFields.forEach(field => {
          const emailValue = field.value.trim()
          if (emailValue && !isValidEmail(emailValue)) {
            const errorMessage = field.nextElementSibling.querySelector('label')
            errorMessage.textContent = 'Veuillez saisir une adresse e-mail valide'
            hasError = true
            if (!firstEmptyField) {
              firstEmptyField = field
            }
          }
        })

        // Fonction pour valider le format de l'e-mail
        function isValidEmail(email) {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          return emailRegex.test(email)
        }

        if (firstEmptyField) {
          firstEmptyField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }

        if (!hasError) {
          form.submit()
        }
        if (modalId) {
          const modal = new Modals()
          modal.openModal(modalId)
        }
      })
    }
  }
}
